const types = {
  GET_CONSIGNMENT_DETAILS_START: 'GET_CONSIGNMENT_DETAILS_DETAILSTART',
  GET_CONSIGNMENT_DETAILS_SUCCESS: 'GET_CONSIGNMENT_DETAILS_SUCCESS',
  GET_CONSIGNMENT_DETAILS_FAILURE: 'GET_CONSIGNMENT_DETAILS_FAILURE',
};

export default types;
